// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-tree[data-v-3f5f79b1] {\n  min-width: 100%;\n  display: inline-block !important;\n}\n.auth[data-v-3f5f79b1] {\n  margin-top: -30px;\n  margin-right: -19px;\n  margin-bottom: -30px;\n  margin-left: -19px;\n}\n.el-scrollbar[data-v-3f5f79b1] {\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
